import { types } from "./deliveryManagementApp.actions";
import { Reducer } from "../../services/reducer.factory";
import moment from "moment";

const initialState = {
  showMapGeral: false,

  dialogMap: {
    visible: false,
    modal: false,
    header: "Mapa"
  },

  dialogCanhoto: {
    visible: false,
    modal: false,
    image: null,
    header: "Comprovante"
  },

  columns: [
    {
      field: "vehicle.plate",
      header: "Veículo",
      columnKey: "number",
      filter: false,
    },
    {
      field: "sequence",
      header: "Peso Total",
      columnKey: "sequence",
      filter: false,
    },
    {
      field: "distance",
      header: "km Planejados",
      columnKey: "distance",
      filter: false,
    },
    {
      field: "deliveryDeadlineDate",
      header: "km Realizados",
      columnKey: "deliveryDeadlineDate",
      filter: false,
    },
    {
      field: "checkpoints",
      header: "Pontos de Entregas",
      columnKey: "checkpoints",
      filter: false,
    },
    {
      field: "diasAtraso",
      header: "Entregas Realizadas",
      columnKey: "diasAtraso",
      filter: false,
    },
    {
      field: "diasAtraso",
      header: "Entregas Pendentes",
      columnKey: "diasAtraso",
      filter: false,
    },

  ],
  columnExpanded: [
    {
      field: "occurrences",
      header: "Ocorrências",
      columnKey: "occurrences",
      filter: false,
    },
  ],
  modalDeliveryDate: {
    visible: false,
    modal: true,
  },
  modalCubageAndVehicleType: {
    visible: false,
    modal: true,
  },
  customFilter: {
    initialDateFilter: moment().startOf("month").toDate(),
    finalDateFilter: moment().toDate(),
    totalOcccurrences: "",
    carrierFilter: {
      oid: null,
      documentNumber: "",
      name: "",
      tradeName: "",
    },
    nfeNumberFilter: null,
    lookupCarrier: {
      visible: false,
      modal: false,
      header: "Transportadora",
    },
    containCustomField: true,
    customFields: null,
    index: 0,
    max: 10,
    count: 0,
  },
  lookupOccurrenceType: {
    visible: false,
    modal: false
  },
  occurrenceTypeFilter: {
    oid: null,
    code: "01",
    description: "Entrega Realizada Normalmente",
    groupType: "",
  },
  additionalDescription: "",
  baixaManual: false,
  // currentRecord: {
  //   oid: null,
  //   number: "",
  //   serie: "",
  //   date: null,
  //   deliveryDate: null,
  //   carrier: null,
  //   value: 0,
  //   occurrences: [],
  //   cubage: 0,
  //   vehicleType: "",
  // },
  selectedRow: null,
  selectCubageVehicleType: {
    nfeID: 0,
    cubage: { value: 0 },
    vehicleType: null,
  },
  deliveryStatusOptions: [
    // { label: "Todos", value: null },
    { label: "Pendentes", value: "TRAVELING" },
    { label: "Concluídas", value: "DELIVERED" },
  ],
  listVehiclesType: [],
  currentFilterDeliveryStatus: ["TRAVELING"],
  backupDeliveryDate: null,
  dateColumnFilter: {
    issueDate: null,
    deliveryDate: null,
    deliveryDeadlineDate: null,
  },
  modalCustomFields: {
    visible: false,
    modal: true,
  },
  recordWithCustomFields: {
    oid: 0,

    listCustomFields: [],
  },
};

const reducer = new Reducer(initialState, types);

export function DeliveryManagementAppReducer(state, action) {
  let result = state;
  if (action.type === types.SET_RECORD) {
    result = Object.assign({}, state, { currentRecord: action.record });
  } else if (action.type === types.SET_FIELD) {
    return setField(state, action);
  } else {
    result = reducer.execute(state, action);
  }
  result = execute(result, action);
  return result;
}

function execute(state, action) {
  let result = state;
  switch (action.type) {
    case types.SET_FIELD_TRACKING_FILTER:
      return setFieldTrackingFilter(state, action);
    case types.SET_FIELD_OCCURRENCE_TYPE_FILTER:
      return setFieldOccurrenceTypeFilter(state, action);
    case types.SET_ADDITIONAL_DESCRIPTION:
      return setAdditionalDesctiption(state, action);
    case types.SET_LOOKUP_CARRIER_VISIBLE:
      return setLookupCarrierVisible(state, action);
    case types.SET_LOOKUP_OCCURENCE_TYPE_VISIBLE:
      return setlookupOccurrenceTypeVisible(state, action);
    case types.LOAD_OCCURRENCE_RECORDS:
      return loadOccurrenceRecords(state, action);
    case types.SET_CURRENT_FILTER_DELIVERY_STATUS:
      return setCurrentFilterDeliveryStatus(state, action);
    case types.SHOW_MODAL_DELIVERY_DATE_VISIBLE:
      return showModalDeliveryDateVisible(state, action);
    case types.BACKUP_DELIVERY_DATE:
      return backupDeliveryDate(state, action);
    case types.SELECT_RECORD:
      return selectedRecord(state, action);
    case types.SET_FIELD_SELECTED_RECORD:
      return setFieldSelectedRecord(state, action);
    case types.SET_DATE_COLUMN_FILTER:
      return setDateColumnFilter(state, action);
    case types.SET_VISIBLED_BTN_DOWNLOAD_CSV:
      return setVisibleBtnDownloadCSV(state, action);
    case types.SHOW_MODAL_CUBAGE_AND_VEHICLE_TYPE_VISIBLE:
      return showModalCubageAndVehicleTypeVisible(state, action);
    case types.SHOW_MODAL_MAP:
      return showModalMap(state, action);

    case types.SET_VEHICLE_TYPE:
      return setVehicleType(state, action);
    case types.SET_CUBAGE:
      return setCubage(state, action);
    case types.SET_NFE_ID:
      return setNFeID(state, action);
    case types.SET_LIST_VEHICLES_TYPE:
      return setListVehiclesType(state, action);
    case types.SHOW_MODAL_CUSTOM_FIELDS:
      return showModalCustomFields(state, action);
    case types.SET_RECORD_CUSTOM_FIELDS:
      return setRecordWithCustomFields(state, action);
    case types.SET_CUSTOM_FIELDS:
      return setCustomFields(state, action);
    case types.ON_REMOVE_CUSTOM_FIELDS:
      return removeItemCustomFieldsHandler(state, action);
    case types.ON_ADD_CUSTOM_FIELDS:
      return onAddNewCustomFieldsHandler(state, action);
    case types.SET_BAIXA_MANUAL:
      return setBaixaManual(state, action);
    case types.APPLY_FILTER:
      return applyFilter(state, action);
    case types.FETCH_RECORDS_CARGO_SHIPMENT:
      return fetchRecordsCargoShipment(state, action)
    case types.SET_CANHOTO_VISIBLE:
      return setCanhotoVisible(state, action)
    case types.SET_MAP_GERAL:
      return setMapGeral(state, action)
    default:
      return result;
  }
}
function setBaixaManual(state, action) {
  let baixaManual = action.baixaManual;
  return { ...state, baixaManual }
}
function removeItemCustomFieldsHandler(state, action) {
  let recordWithCustomFields = state.recordWithCustomFields

  if (!recordWithCustomFields.listCustomFields)
    recordWithCustomFields.listCustomFields = [];

  if (recordWithCustomFields.listCustomFields && recordWithCustomFields.listCustomFields.length > 0) {
    recordWithCustomFields.listCustomFields = recordWithCustomFields.listCustomFields.filter(item => item.uuid != action.item.uuid)
  }

  if (recordWithCustomFields.listCustomFields.length == 0) {
    recordWithCustomFields.listCustomFields.push({
      uuid: crypto.randomUUID(),
      campo: "",
      value: "",
    });
  }

  return { ...state, recordWithCustomFields }
}

function onAddNewCustomFieldsHandler(state, action) {
  let recordWithCustomFields = state.recordWithCustomFields;
  if (!recordWithCustomFields) {
    recordWithCustomFields = {
      listCustomFields: []
    }
  }

  let listCustomFields = recordWithCustomFields.listCustomFields
  if (!listCustomFields)
    listCustomFields = [];

  listCustomFields.push({
    uuid: crypto.randomUUID(),
    campo: "",
    value: "",
  });
  recordWithCustomFields.listCustomFields = listCustomFields;
  return { ...state, recordWithCustomFields }
}

function setCustomFields(state, action) {
  let recordWithCustomFields = state.recordWithCustomFields;
  if (!recordWithCustomFields) {
    recordWithCustomFields = {
      listCustomFields: []
    }
  }

  let listCustomFields = recordWithCustomFields.listCustomFields
  if (!listCustomFields)
    listCustomFields = [];
  for (let i = 0; i < listCustomFields.length; i++) {
    if (listCustomFields[i].uuid == action.uuid) {
      listCustomFields[i][action.field] = action.value;
    }
  }
  recordWithCustomFields.listCustomFields = listCustomFields;
  return { ...state, recordWithCustomFields }
}

function setRecordWithCustomFields(state, action) {
  let recordWithCustomFields = action.data;
  if (recordWithCustomFields) {
    const listCustomFields = []
    if (recordWithCustomFields) {
      for (const [key, value] of Object.entries(recordWithCustomFields.customFields)) {
        listCustomFields.push({
          uuid: crypto.randomUUID(),
          campo: key,
          value: value,
        });
      }
    }
    if (listCustomFields.length == 0) {
      listCustomFields.push({
        uuid: crypto.randomUUID(),
        campo: "",
        value: "",
      });
    }

    recordWithCustomFields["listCustomFields"] = listCustomFields;
  }
  return { ...state, recordWithCustomFields }
}
function showModalCustomFields(state, action) {
  let modalCustomFields = state.modalCustomFields;
  modalCustomFields.visible = action.visible;
  return { ...state, modalCustomFields }
}


function setVisibleBtnDownloadCSV(state, action) {
  state = Object.assign({}, state, { disabledBtnDownloadCSV: action.value });
  return state;
}

function setVehicleType(state, action) {
  let selectCubageVehicleType = state.selectCubageVehicleType;
  selectCubageVehicleType.vehicleType = action.value;
  return { ...state, selectCubageVehicleType };
}
function setCubage(state, action) {
  let selectCubageVehicleType = state.selectCubageVehicleType;
  selectCubageVehicleType.cubage = action.value;
  return { ...state, selectCubageVehicleType };
}
function setNFeID(state, action) {
  let selectCubageVehicleType = state.selectCubageVehicleType;
  selectCubageVehicleType.nfeID = action.value;
  return { ...state, selectCubageVehicleType };
}
function setListVehiclesType(state, action) {
  let listVehiclesType = state.listVehiclesType;
  listVehiclesType = action.data;
  return { ...state, listVehiclesType };
}

function setDateColumnFilter(state, action) {
  let dateColumnFilter = state.dateColumnFilter;
  dateColumnFilter = Object.assign({}, dateColumnFilter, {
    [action.field]: action.value,
  });
  return { ...state, dateColumnFilter };
}

function selectedRecord(state, action) {
  const selectedRow = action.record;
  return { ...state, selectedRow };
}

function backupDeliveryDate(state, action) {
  const backupDeliveryDate = action.deliveryDate;
  return { ...state, backupDeliveryDate };
}

function showModalDeliveryDateVisible(state, action) {
  let modalDeliveryDate = state.modalDeliveryDate || {};
  modalDeliveryDate.visible = action.visible;
  return Object.assign({}, state, { modalDeliveryDate });
}

function showModalMap(state, action) {
  let dialogMap = state.dialogMap;
  dialogMap.visible = action.value;
  return { ...state, dialogMap }

}

function showModalCubageAndVehicleTypeVisible(state, action) {
  let modalCubageAndVehicleType = state.modalCubageAndVehicleType || {};
  modalCubageAndVehicleType.visible = action.visible;
  return Object.assign({}, state, { modalCubageAndVehicleType });
}

function setFieldSelectedRecord(state, action) {
  let selectedRow = state.selectedRow || {};
  const { field, value } = action;
  const fields = field && field.split(".");
  const lastField = fields[fields.length - 1];
  let record = selectedRow;
  if (fields.length > 1) {
    for (let i = 0; i < fields.length - 1; i++) {
      const owner = record;
      record = record[fields[i]];
      if (!record) {
        record = {};
        owner[fields[i]] = record;
      }
    }
  }
  record[lastField] = value;
  selectedRow = record;
  return Object.assign({}, state, { selectedRow });
}

function setField(state, action) {
  let currentRecord = state.currentRecord || {};
  const { field, value } = action;
  const fields = field && field.split(".");
  const lastField = fields[fields.length - 1];
  let current = currentRecord;
  if (fields.length > 1) {
    for (let index = 0; index < fields.length - 1; index++) {
      const owner = current;
      current = current[fields[index]];
      if (!current) {
        current = {};
        owner[fields[index]] = current;
      }
    }
  }

  current[lastField] = value;
  return Object.assign({}, state, { currentRecord });
}

function setLookupCarrierVisible(state, action) {
  let filter = state.filter;
  let lookupCarrier = filter.lookupCarrier;
  lookupCarrier = Object.assign({}, lookupCarrier, { visible: action.visible });
  filter = Object.assign({}, filter, { lookupCarrier });
  state = Object.assign({}, state, { filter });
  return state;
}
function setlookupOccurrenceTypeVisible(state, action) {
  let lookupOccurrenceType = state.lookupOccurrenceType
  lookupOccurrenceType.visible = action.visible
  state = { ...state, lookupOccurrenceType }
  return state;
}

function setFieldTrackingFilter(state, action) {
  let customFilter = state.customFilter;
  customFilter = Object.assign({}, customFilter, {
    [action.fieldName]: action.fieldValue,
  });
  state = Object.assign({}, state, { customFilter });
  return state;
}

function setFieldOccurrenceTypeFilter(state, action) {
  let occurrenceTypeFilter = state.occurrenceTypeFilter;
  occurrenceTypeFilter = action.fieldValue;
  return { ...state, occurrenceTypeFilter };
}
function setAdditionalDesctiption(state, action) {
  let additionalDescription = state.additionalDescription;
  additionalDescription = action.additionalDescription;
  return { ...state, additionalDescription };
}


function loadOccurrenceRecords(state, action) {
  let currentNFeRecord = state.currentNFeRecord;
  currentNFeRecord = Object.assign({}, currentNFeRecord, {
    occurrences: action.occurrenceRecords,
  });
  state = Object.assign({}, state, { currentNFeRecord });
  return state;
}

function setCurrentFilterDeliveryStatus(state, action) {
  state = Object.assign({}, state, {
    currentFilterDeliveryStatus: action.currentFilterDeliveryStatus,
  });
  return state;
}

function applyFilter(state, action) {
  let filter = action.filterParams
  return { ...state, filter }
}

function fetchRecordsCargoShipment(state, action) {
  let records = action.record
  return { ...state, records }
}

function setCanhotoVisible(state, action) {
  let dialogCanhoto = state.dialogCanhoto
  dialogCanhoto.visible = action.value
  dialogCanhoto.image = action.image
  return { ...state, dialogCanhoto }
}

function setMapGeral(state, action) {
  let showMapGeral = state.showMapGeral
  showMapGeral = action.value
  return { ...state, showMapGeral }
}